import axios from "axios";
import safeLogger from "./utils/safeLogger";

const api = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "https://codefort.onrender.com"
      : "https://codefort.onrender.com",
  headers: {
    "Content-Type": "application/json",
  },
});

// Adiciona token de autenticação (se necessário)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Lida com erros globalmente (opcional)
api.interceptors.response.use(
  (response) => response,
  (error) => {
      try {
        safeLogger.error({
          tag: "api_request_error",
          message: error.message,
          status: error.response?.status,
          data: safeLogger.mask(error.response?.data),
          request: {
            url: error.config?.url,
            method: error.config?.method,
            data: safeLogger.mask(error.config?.data),
          },
        });
      } catch (e) {
        safeLogger.error("Erro ao logar detalhes do erro");
      }
    return Promise.reject(error);
  }
);

export const renewSubscription = async (email) => {
  safeLogger.info({ tag: "renew_subscription", data: safeLogger.mask({ email }) });
  const response = await api.post("/auth/renew", { email });
  safeLogger.info({ tag: "renew_subscription_response", data: safeLogger.mask(response.data) });
  return response;
};

export default api;
